(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolor-product-information"]) return;
  try {
    
(function () {
  'use strict';

  /*
    Move the multicolor picker from its hidden source node into the
    .product-details column, directly before .buy-buttons-block so it
    sits naturally in the product info flow.

    Why JS injection instead of Liquid?
      The _product-details block is a theme "static" block rendered via
      content_for — we cannot intercept its internal block order from
      the section Liquid. JS is the only way to insert between blocks.
  */
  function injectPicker() {
    var source = document.querySelector('[data-mc-picker-source]');
    if (!source) return;

    var picker = source.querySelector('.multicolor-picker');
    if (!picker) return;

    /* Target: .product-details inside the product-information section */
    var productDetails = document.querySelector(
      '[data-testid="product-information"] .product-details, [data-testid="product-information-details"]'
    );

    /* Wrap the picker in a block-level container that matches spacing */
    var wrapper = document.createElement('div');
    wrapper.className = 'mc-picker-injected';
    wrapper.appendChild(picker);

    if (productDetails) {
      /*
        Preferred position: just before .buy-buttons-block.
        The buy-buttons block renders as a div with class "buy-buttons-block"
        (confirmed via quick-add-modal-styles.liquid).
      */
      var buyButtonsBlock = productDetails.querySelector('.buy-buttons-block');

      if (buyButtonsBlock) {
        buyButtonsBlock.parentNode.insertBefore(wrapper, buyButtonsBlock);
      } else {
        /* Fallback: append to end of .product-details */
        productDetails.appendChild(wrapper);
      }
    } else {
      /*
        Last resort: show inline after the product grid.
        Make the source visible and append the wrapper to it.
      */
      source.style.display = 'block';
      source.appendChild(wrapper);
      source.style.display = '';
    }

    /* Remove the now-empty source placeholder */
    source.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectPicker);
  } else {
    injectPicker();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
